import { z } from 'zod';
import { actorTypeSchema, actorSystemSourceSchema } from '../../actor/actor.mjs';
import { Currency } from '../../currency/currency.mjs';
import { rateSchemaV2, userId } from '../../opaque.mjs';
import { currencySchema } from '../../utils.mjs';

const singleExceedsAggregateMessage = "Single limit cannot exceed the aggregate limit";
const positiveRateMessage = "Rate must be greater than zero";
const negativeLimitMessage = "Limits cannot be negative";
const rateSchema = rateSchemaV2.refine((val) => val > 0, {
    error: positiveRateMessage,
});
const limitSchema = currencySchema
    .refine((val) => val >= 0, {
    error: negativeLimitMessage,
})
    .transform(Currency.round);
const schema = z
    .object({
    rate: rateSchema,
    singleLimit: limitSchema,
    aggregateLimit: limitSchema,
})
    .refine((line) => line.singleLimit <= line.aggregateLimit, {
    path: ["singleLimit"],
    error: singleExceedsAggregateMessage,
});
var UpdatedBy;
(function (UpdatedBy) {
    UpdatedBy.typeSchema = actorTypeSchema.extract(["user", "system"]);
    UpdatedBy.userSchema = z.object({ type: UpdatedBy.typeSchema.extract(["user"]), userId });
    UpdatedBy.systemSchema = z.object({
        type: UpdatedBy.typeSchema.extract(["system"]),
        source: actorSystemSourceSchema,
    });
    UpdatedBy.schema = z.discriminatedUnion("type", [UpdatedBy.userSchema, UpdatedBy.systemSchema]);
})(UpdatedBy || (UpdatedBy = {}));

export { UpdatedBy, negativeLimitMessage, positiveRateMessage, schema, singleExceedsAggregateMessage };
